import type { FC } from "react";

import { FormCheckbox as FormCheckboxUI } from "@jti/ui/components/ContactForm";

import type { formCheckboxInputs } from "./FormCheckbox.builder";

export type FormCheckboxProps = BuilderComponentProps<typeof formCheckboxInputs>;

export const FormCheckbox: FC<FormCheckboxProps> = ({ id, label, isCheckedByDefault, required, requiredMessage }) => {
  return (
    <FormCheckboxUI
      id={id}
      label={label}
      validationRules={{
        required: required ? requiredMessage || true : false,
      }}
      isCheckedByDefault={isCheckedByDefault}
    />
  );
};
